<template>
  <div>
    <van-nav-bar
      safe-area-inset-top
      left-arrow
      @click-left="onClickLeft"
      title="征集配方"
      fixed
    />
    <div style="height:60px;"> </div>
      <div v-for="(item,index) in collectionData" :key="index"  class="tab-box1-style van-hairline--bottom">
        <div class="item-box" @click="uploadCollectionRecipe(item)">
          <van-row>
            <van-col span="6" style="border-right: 1px solid #F3F3F8;">
              <div class="box-left-one" >
                <img v-if="item.topCollection === 'true'" style="height:50px;" src="../../assets/image/zj_top.png" alt="" />
                <img v-else-if="item.isNew === true" style="height:50px;" src="../../assets/image/zj_new.png" alt="" />
                <div v-else style="height:50px;" ></div>
              </div>
              <div>
                <div class="row-point-txt" v-if="item.topCollection === 'true'" >{{item.bonusPoint}}</div>
                <div class="row-point-txt-block" v-else >{{item.bonusPoint}}</div>
                <div class="row-label-txt" v-if="item.topCollection === 'true'" >奖励积分</div>
                <div class="row-label-txt-block" v-else >奖励积分</div>
              </div>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="17">
              <div>
                <div class="box-right-one">
                  <div style="font-weight: 600;font-size: 13px;width:50%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;align-items: center;" >{{item.colorText}}</div>
                  <div style="margin-left:2%;display:flex;justify-content: end;align-items: center;width:42%;">
                    <div class="icon-circle">
                      <span class="icon-circle-class">{{item.paintBrandName}}</span>
                    </div>
                  </div>
                </div>
                <div class="box-right-two">
                  <div v-if="item.carBrandName&&item.carModelName" style="color:#3B8AF2;font-size: 13px;" >{{item.carBrandName}}-{{item.carModelName}}</div>
                  <div v-else style="color:#3B8AF2;font-size: 13px;" >{{item.carBrandName}}</div>
                </div>
                <div class="box-right-three">
                  <div style="font-size: 13px;width:50%;" >征集进度:{{item.uploadedNum}}/{{item.collectNum}}</div>
                  <div style="display:flex;justify-content: center;width: 45%;">
                    <div class="upload-btn" @click="uploadCollectionRecipe(item)">立即上传</div>
                  </div>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    
  </div>
</template>

<script>
import Api from "../../api/api";
import storeState from '../../store/index'  //storeId就是导出的那个值
import {formatDate} from "../../common/date";
export default {
  name: "Home",
  data() {
    return {
      collectionData:[],
      // collectionData:[{
      //   collectionId:1,//征集ID
      //   paintBrandCode:"NBS1K",
      //   paintBrandCodeStr:"NBS1K",
      //   paintBrandName:"诺缤（溶剂型1K）",
      //   oemId:"6f7990d9c6d446eb9e101dbcc91d05d4",
      //   carBrandId:"ead8e2c9613c49adbcc0dcdb5ed74f86",
      //   carBrandName:"丰田",
      //   carModelId:"86945ba36f80450c999c65d68b63816c",
      //   carModelName:"通用",
      //   colorCodeId:"",
      //   colorCode:"111",
      //   colorName:"qqq",
      //   collectNum:"5",
      //   uploadedNum:"1",
      //   bonusPoint:"100",
      //   collectRegion:"",
      //   collectRegionName:"",
      //   topCollection:true,
      //   needVerify:"",
      //   releaseTime:"2024-07-01T13:55:33",
      //   status:"1",
      // },{
      //   collectionId:1,//征集ID
      //   paintBrandCode:"NBS1K",
      //   paintBrandCodeStr:"NBS1K",
      //   paintBrandName:"诺缤（溶剂型1K）",
      //   oemId:"6f7990d9c6d446eb9e101dbcc91d05d4",
      //   carBrandId:"ead8e2c9613c49adbcc0dcdb5ed74f86",
      //   carBrandName:"丰田",
      //   carModelId:"86945ba36f80450c999c65d68b63816c",
      //   carModelName:"通用",
      //   colorCodeId:"",
      //   colorCode:"111",
      //   colorName:"qqq",
      //   collectNum:"5",
      //   uploadedNum:"1",
      //   bonusPoint:"100",
      //   collectRegion:"",
      //   collectRegionName:"",
      //   topCollection:false,
      //   isNew:true,
      //   needVerify:"",
      //   releaseTime:"2024-07-01T13:55:33",
      //   status:"1",
      // },{
      //   collectionId:3,//征集ID
      //   paintBrandCode:"NBS1K",
      //   paintBrandCodeStr:"NBS1K",
      //   paintBrandName:"诺缤(溶剂型1K)",
      //   oemId:"6f7990d9c6d446eb9e101dbcc91d05d4",
      //   carBrandId:"ead8e2c9613c49adbcc0dcdb5ed74f86",
      //   carBrandName:"丰田",
      //   carModelId:"86945ba36f80450c999c65d68b63816c",
      //   carModelName:"通用",
      //   colorCodeId:"e16cbe48cbc84e9bab4d2e1a1280c",
      //   colorCode:"8Q4",
      //   colorName:"DARK BLUE222",
      //   colorRgb:"001E3A",

      //   collectNum:"5",
      //   uploadedNum:"1",
      //   bonusPoint:"100",
      //   collectRegion:"",
      //   collectRegionName:"",
      //   topCollection:false,
      //   isNew:false,
      //   needVerify:"",
      //   releaseTime:"2024-07-01T13:55:33",
      //   status:"1",
      // },{
      //   collectionId:3,//征集ID
      //   paintBrandCode:"NBS1K",
      //   paintBrandCodeStr:"NBS1K",
      //   paintBrandName:"诺缤(溶剂型1K)",
      //   oemId:"6f7990d9c6d446eb9e101dbcc91d05d4",
      //   carBrandId:"ead8e2c9613c49adbcc0dcdb5ed74f86",
      //   carBrandName:"丰田",
      //   carModelId:"86945ba36f80450c999c65d68b63816c",
      //   carModelName:"通用",
      //   colorCodeId:"e16cbe48cbc84e9bab4d2e1a1280c",
      //   colorCode:"8Q4",
      //   colorName:"DARK BLUE222",
      //   colorRgb:"001E3A",

      //   collectNum:"5",
      //   uploadedNum:"1",
      //   bonusPoint:"100",
      //   collectRegion:"",
      //   collectRegionName:"",
      //   topCollection:false,
      //   isNew:false,
      //   needVerify:"",
      //   releaseTime:"2024-07-01T13:55:33",
      //   status:"1",
      // },{
      //   collectionId:3,//征集ID
      //   paintBrandCode:"NBS1K",
      //   paintBrandCodeStr:"NBS1K",
      //   paintBrandName:"诺缤(溶剂型1K)",
      //   oemId:"6f7990d9c6d446eb9e101dbcc91d05d4",
      //   carBrandId:"ead8e2c9613c49adbcc0dcdb5ed74f86",
      //   carBrandName:"丰田",
      //   carModelId:"86945ba36f80450c999c65d68b63816c",
      //   carModelName:"通用",
      //   colorCodeId:"e16cbe48cbc84e9bab4d2e1a1280c",
      //   colorCode:"8Q4",
      //   colorName:"DARK BLUE222",
      //   colorRgb:"001E3A",

      //   collectNum:"5",
      //   uploadedNum:"1",
      //   bonusPoint:"100",
      //   collectRegion:"",
      //   collectRegionName:"",
      //   topCollection:false,
      //   isNew:false,
      //   needVerify:"",
      //   releaseTime:"2024-07-01T13:55:33",
      //   status:"1",
      // }],//征集配方列表
    };
  },
  mounted() {
    this.queryCollectionRecipeList();
  },
 
  methods: {
    //征集配方列表
    queryCollectionRecipeList() {
      let nowDate=new Date();
      let beginDate=nowDate.setDate(nowDate.getDate()-6);
      console.log(formatDate(beginDate));
      let endDate=new Date();
      console.log(formatDate(endDate));
      
      Api.queryCollectionRecipeList({}).then((res) => {
        console.log("征集配方列表",res);
        let collectionList=[];
        if (res.data.success && res.data.result.length > 0) {
          for(let i=0;i<res.data.result.length;i++){
            let releaseTimeStr = res.data.result[i].releaseTime.substring(0,10);
            if(releaseTimeStr>=formatDate(beginDate)&&releaseTimeStr<=formatDate(endDate)){
              res.data.result[i].isNew=true;
            }else{
              res.data.result[i].isNew=false;
            }
            let colorText=res.data.result[i].colorCode+res.data.result[i].colorName;
            res.data.result[i].colorText=colorText.length>14?colorText.substring(0,14)+"...":colorText;
            collectionList.push(res.data.result[i]);
          }
        }

        this.collectionData = collectionList;
      });
    },

    //立即上传征集配方
    uploadCollectionRecipe(item) {
      const storeStates = storeState()
      storeStates.addColor = null;
      storeStates.collectionRecipeItem = item;
      this.$router.push({
        path:'/app-h5-cn/page/addCorNum',
        query: {
          active: '1'
        }
      });
    },

    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-box {
  margin-top: 10px;
  width: 90%;
  margin-left: 5%;
  display: flex;
  .marquee_title {
    width: 15%;
    color: #0092FF;
    font-size: 14px;
    // margin-top: 6px;
    .span1 {
        margin-top: 7px;
        font-weight: 600;
    }
    .span2 {
        margin-top: 3px;
        font-weight: 600;
    }
  }
}
.marquee {
  width: 100%;
  height: 60px;
  align-items: center;
  /* color: #3A3A3A; */
//   background-color: #fdfbde;
  display: flex;
  /* box-sizing: border-box; */
}

.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 60px;
  overflow: hidden;
}

.marquee_list {
  display: block;
  position: absolute;
  width:100%;
  top: 0;
  left: 0;
  .gong-style {
    color:#6D6D6E;
    font-size:13px;
    position: relative;
    top: 3px;
    font-weight: 600;
  }
  .gong-styles {
    color:#6D6D6E;
    font-size:13px;
    position: relative;
    top: 3px;
    float: right;
  }
}

.marquee_top {
  transition: all 0.5s;
  margin-top: -60px;
}

.marquee_list div {
  width: 100%;
  height: 60px;
  line-height: 30px;
  font-size: 12px;
}

.marquee_list div span {
  padding: 0 2px;
}
.divover {
    font-size: 13px;
    color: #949599;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    position: relative;
    top: -6px;
}
.tab-box1-style {
    width: 100%;
    height: 100%;
    // height: 65px;
    // background-color: antiquewhite;
    display: flex;
    .box1-style {
        width: 80px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // background-color: yellow;
        .img-size-style {
            width: 50px;
        }
    }
    .box2-style {
        width: calc(100% - 140px);
        height: 100%;
        // background-color: #BCBCBD;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span {
            font-size: 13px;
            color: #6D6D6E;
        }
        .span-color {
            color: #949599;
            font-size: 12px;
        }
    }
    .boxs2-style {
        width: calc(100% - 90px);
        height: 100%;
        // background-color: #BCBCBD;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span {
            font-size: 13px;
            color: #6D6D6E;
        }
        .span-color {
          color: #949599;
          font-size: 11px;
        }
    }
    .box3-style {
        width: 90px;
        height: 100%;
        display: flex;
        flex-direction: column ;
        justify-content: center;
        align-items: center;
        // background-color: aqua;
    }
}

.item-box{
  margin:10px 5%;
  width:90%;
  border-radius:5px;
  background-color:white;
}
.box-left-one{
  display:flex;
  justify-content: center;
  margin-bottom:8px;
}
.row-point-txt{
  color:#E69937;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin-bottom:5px;
}
.row-point-txt-block{
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin-bottom:5px;
}
.row-label-txt{
  color:#E69937;
  text-align: center;
  font-size: 13px;
  margin-bottom:10px;
}
.row-label-txt-block{
  text-align: center;
  font-size: 13px;
  margin-bottom:10px;
}
.box-right-one{
  display:flex;
  margin-top:10px;
}
.box-right-two{
  display:flex;
  margin-top:10px;
}
.box-right-three{
  display:flex;
  margin-top:10px;
  align-items:center;
}
.icon-circle {
  all: initial;
  padding: 1px 6px;
  height: 20px;
  border-radius: 10px;
  width:90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #E7EAF3;
  color:  #666666;
  // padding: 1px 10px;
  // padding-left: .2667rem;
  // padding-right: .2667rem;
  // padding-bottom: .17rem;
  // margin-right: .75rem;
  // margin-left: .6rem;
}
.icon-circle-class {
  font-size: 10px;
  // padding-top: 1px;
}

.upload-btn {
  all: initial;
  padding: 3px 15px;
  height: 1.6rem;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color:  #333333;
  border:1px solid #EEEEEE;
  font-size: 13px;
}

/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-nav-bar__text {
    color: black !important;
}
/deep/ .van-tabs__line {
    width: 50%;
    background-color:#0092FF; //#BCBCBD 100%
}
/deep/ .van-button--round {
        width: 70px;
        font-size: 10px;
        height: 21px;
    }
/deep/ .van-tab--active {
    color: #0092FF ;
}
/deep/ .van-tab {
    font-size: 16px;
}
/deep/ .van-tab__text--ellipsis {
    font-weight: 600;
}
/deep/ .van-tab__pane, .van-tab__pane-wrapper {
    background-color: #fff;
    padding-bottom: 20px;
}
</style>

